<template>
  <div class="row">
    <div class="small-12 columns">
      <h1>Add Coupon</h1>
      <div class="row">
        <div class="small-4 columns">Name</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.name"
            type="text"
            class="input-box-course-creators"
          />
        </div>
      </div>
      <div class="row">
        <div class="small-4 columns">is_automatic</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.is_automatic"
            type="checkbox"
            class="input-box-course-creators"
            @change="coupon.is_manual = false"
          />
        </div>
      </div>
      <div class="row">
        <div class="small-4 columns">is_percentage</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.is_percentage"
            type="checkbox"
            class="input-box-course-creators"
          />
        </div>
      </div>
      <div class="row">
        <div class="small-4 columns">is_special</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.is_special"
            type="checkbox"
            class="input-box-course-creators"
          />
        </div>
      </div>
      <div class="row">
        <div class="small-4 columns">is_manual</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.is_manual"
            type="checkbox"
            class="input-box-course-creators"
            @change="coupon.is_automatic = false"
          />
        </div>
      </div>
      <!--  -->
      <!-- Users[Array] search by email  -->

      <div v-if="coupon.is_special || coupon.is_manual" class="row">
        <div class="small-4 columns"><div>Users</div></div>
        <div class="small-8 columns">
          <VueSelect
            v-model="coupon.users"
            multiple
            :searchable="true"
            :options="usersOptions"
            label="email"
            @search="getUsers"
          />
        </div>
      </div>

      <!--  -->
      <div class="row">
        <div class="small-4 columns">
          coupon value

          <span v-if="coupon.is_percentage">(Percentage)</span>
          <span v-if="!coupon.is_percentage">(Paise)</span>
        </div>
        <div class="small-8 columns">
          <small class="text-green-dark">Rs. {{ rupee }}/-</small>
          <input
            v-model="coupon.coupon_value"
            type="number"
            class="input-box-course-creators"
          />
        </div>
      </div>
      <!-- Coupon JSON -->
      <!--  -->
      <div class="row cutoff-container">
        <h3>Cut Off</h3>
        <div class="small-4 columns">Game Cut Off</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.cut_off.game"
            type="text"
            class="input-box-course-creators"
          />
        </div>

        <div class="small-4 columns">Code Cut Off</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.cut_off.code"
            type="text"
            class="input-box-course-creators"
          />
        </div>

        <div class="small-4 columns">MCQ Cut Off</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.cut_off.mcq"
            type="text"
            class="input-box-course-creators"
          />
        </div>

        <div class="small-4 columns">Video Cut Off</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.cut_off.video"
            type="text"
            class="input-box-course-creators"
          />
        </div>
      </div>
      <!--  -->
      <!-- END OF COUPON JSON -->
      <div class="row">
        <div class="small-12 columns">
          <button class="button-green" @click="addCoupon">Add Coupon</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { VueSelect },
  data() {
    return {
      coupon: {
        name: undefined,
        is_automatic: false,
        is_percentage: false,
        coupon_value: 0,
        is_special: false,
        is_manual: false,
        users: [],

        cut_off: {
          game: 0,
          mcq: 0,
          code: 0,
          video: 0,
        },
      },
      usersOptions: [],
    }
  },
  computed: {
    rupee() {
      return this.coupon.coupon_value / 100
    },
  },
  methods: {
    debouncer() {
      return window._.debounce(this.makeRequest, 2000)
    },
    makeRequest(text) {
      // console.log(text);
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}users/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        params: { search_text: text },
      }).then(res => {
        this.usersOptions = res.data.users
      })
    },
    getUsers(text) {
      this.debouncer(text)(text)
    },
    addCoupon() {
      this.coupon.coupon_value = parseInt(this.coupon.coupon_value)
      this.coupon.cut_off.game = parseInt(this.coupon.cut_off.game)
      this.coupon.cut_off.mcq = parseInt(this.coupon.cut_off.mcq)
      this.coupon.cut_off.code = parseInt(this.coupon.cut_off.code)
      this.coupon.cut_off.video = parseInt(this.coupon.cut_off.video)
      this.coupon.users = this.coupon.users.map(item => item.id)
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}coupons/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: this.coupon,
      }).then(() => {
        this.$router.push("/coupons/")
      })
    },
  },
}
</script>

<style>
.cutoff-container {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #cac7c7;
  background-color: #efefef;
}
</style>
